import { userApiClient } from '../httpClient'

export async function getCurrentUser(): Promise<any> {
    return await userApiClient.get(`api/v1/user`)
}

export async function getUserById(id: string): Promise<any> {
    return await userApiClient.get(`api/v1/user/${id}`)
}

export async function updateUser(user: any): Promise<any> {
    return await userApiClient.put(`api/v1/user`, user)
}

export async function updateDentalForm(formData: { [key: string]: any }): Promise<any> {
    return await userApiClient.post('api/v1/user/dental-form', formData)
}

export async function getSavedDentalForm() {
    return await userApiClient.get<{ [key: string]: any }>('api/v1/user/dental-form')
}

export async function deleteDentalFormClaim() {
    return await userApiClient.delete('api/v1/user/dental-form')
}
